<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input class="filter-item" v-model="sn" ref="sn" placeholder="请使用扫码设备获取条码号" clearable style="width: 300px;" @keyup.enter.native="handleFilter"></el-input>
      <el-button v-waves class="filter-item" type="primary" icon="el-icon-search" style="margin-left: 10px;" :loading="loading" @click="handleFilter">查询</el-button>
      <div class="tip" v-if="dash && dash.pack != undefined">
        <el-link type="primary" @click="$router.push('/work/stats/index?k=pack')">今日入库: {{ dash.pack }}</el-link>
      </div>
    </div>

    <div class="main ds">
      <el-form :model="work" label-position="left" label-width="100px" inline class="expand" style="margin: 0 20px;">
        <el-form-item :label="row.name" v-for="(row, idx) in tpl" :key="idx">
          <el-input class="txt" v-model="work[row.key]" clearable :placeholder="row.tip" :disabled="!row.write" v-if="row.type == 'txt'"/>
          <el-select class="sel" v-model="work[row.key]" clearable :placeholder="row.tip" :disabled="!row.write" v-if="row.type == 'sel'">
						<el-option v-for="kv in row.option" :key="kv.k" :label="kv.v" :value="kv.k"></el-option>
          </el-select>
					<el-date-picker class="cal" v-model="work[row.key]" type="date" clearable :placeholder="row.tip" :disabled="!row.write" v-if="row.type == 'cal'"></el-date-picker>
					<el-checkbox class="chk" v-model="row.check" v-if="row.next">下同</el-checkbox>
        </el-form-item>
      </el-form>
    </div>

    <div class="action">
      <el-button class="btn" type="info" plain @click="doClear(true)">清空</el-button>
      <el-button class="btn" type="primary" @click="doStore">确认</el-button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
import waves from '@/directive/waves'

export default {
  name: 'Scrap',
  directives: {
    waves
  },
  data() {
    let tpl = [
      {key: 'sn', name: '条码号', type: 'txt', write: false, tip: '请扫码获取条码号'},
      {key: 'spec', name: '规格', type: 'txt', write: false, tip: '请扫码获取规格'},
      {key: 'inno', name: '内部编号', type: 'txt', write: false, tip: '请扫码获取内部编号'},
      {key: 'day', name: '检定时间', type: 'cal', write: false, tip: '请扫码获取检定时间'},
      {key: 'life', name: '年限', type: 'sel', write: false, option: [{k:1, v:'一年'}, {k:2, v:'二年'}, {k:3, v:'三年'}], tip: '请扫码获取年限'},
      {key: 'user', name: '检定人', type: 'txt', write: false, tip: '请扫码获取检定人'},
      {key: 'level', name: '级别', type: 'txt', write: false, tip: '请扫码获取级别'},
      {key: 'team', name: '分配组', type: 'txt', write: false, tip: '请扫码获取分配组'},
      {key: 'scrap_why', name: '报废原因', type: 'txt', write: true, next: true, tip: '请填写报废原因'},
      {key: 'scrap_who', name: '报废人', type: 'txt', write: true, next: true, tip: '请填写报废人'}
    ]
    let work = {}
    tpl.forEach(row => {
      work[row.key] = null
    })
    return {
      loading: false,
      sn: '',
      work,
      tpl
    }
  },
  computed: {
    ...mapState({
      dash: state => state.work.dash
    })
  },
  created() {
    const _t = this
    setTimeout(function () {
      _t.$refs['sn'].$el.children[0].focus()
    }, 200)
  },
  methods: {
    handleFilter() {
      const _t = this
      const data = {
        sn: _t.sn.trim()
      }
      if (!data.sn) {
        return
      }

      _t.loading = true

      _t.$http.post('/api/ware/info/',  data).then(resp => {
        if (resp.data) {
          let map = []
          _t.tpl.forEach(row => {
            if (!row.write) {
              map.push(row.key)
            }
          })
          for (let k in resp.data) {
            if (Object.prototype.hasOwnProperty.call(_t.work, k) && map.indexOf(k) > -1) {
              _t.work[k] = resp.data[k]
            }
          }
        }
        setTimeout(() => {
          _t.loading = false
        }, 500)
      }).catch(() => {
        _t.loading = false
      })
    },
    doClear(flag) {
      const _t = this
      _t.tpl.forEach(row => {
        if (flag || !row.check) {
          switch (row.type) {
            case 'sel':
            case 'cal':
              _t.work[row.key] = null
              break
            case 'txt':
              _t.work[row.key] = ''
              break
          }
        }
      })
    },
    doStore() {
      const _t = this
      let data = Object.assign({}, _t.work)
      if (!data.sn) {
        _t.$message.warning('请先点击查询获取条码号')
        return
      }

      const loading = this.$loading({
        target: '.main',
        lock: true,
        text: '数据提交中，请稍等'
      })

      _t.$http.post('/api/ware/scrap/',  data).then(resp => {
        if (resp.code == 0) {
          _t.$message.success(resp.msg)
          _t.$refs['sn'].$el.children[0].focus()
          _t.sn = ''
          _t.doClear()
        }
        setTimeout(() => {
          loading.close()
        }, 500)
      }).catch(() => {
        loading.close()
      })
    }
  }
}
</script>

<style lang="scss">
.filter-container {
  border-bottom: 1px dashed #ddd;
  padding-bottom: 1px;
  margin-bottom: 10px;
}
.expand {
  font-size: 0;
  label {
    width: 90px;
    color: #99a9bf;
  }
  .el-form-item {
    margin-right: 0;
    width: 50%;
  }
}
</style>

<style lang="scss" scoped>
.main {
	.txt, .sel {
    width: 220px;
  }
	.chk {
		margin-left: 10px;
	}
}
.action {
  text-align: center;
  .btn {
    width: 200px;
    margin: 30px 20px;
  }
}
</style>
